module.exports = __webpack_public_path__ + "img/Dantam Hair 59.0aef7dd4.jpg";